import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScrollBar = _resolveComponent("ScrollBar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ScrollBar, {
      ref: "scroller",
      class: _normalizeClass(["scroller", {scrollable: $data.scrollable, start: $data.start, end: $data.end}]),
      onScroll: $options.handleScroll
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", null, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class", "onScroll"])
  ]))
}